import { createRequestFields, createInitialFormData } from "src/models/common/form_modal";
import { Distributor } from "./distributor.model";
import { Pagination } from "src/models/common/table_main";

export interface DistributorRequest {
    nameSoldTo: string;
    nameShipTo: string;
    soldTo: string;
    shipTo: string;
    nameShipToSAP : string;
    createdBy?: string;
    updatedBy?: string;
  }
  
  export interface SubmitRequest {
    importItems: Array<DistributorRequest>;
    userId: string;
  }
  
  export interface DistributorState {
    data: Distributor[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string;
  }
  
  export const distributorInitialState: DistributorState = {
    data: null,
    pagination:null,
    loading: false,
    error: false,
    errorMessage: null,   
  };
  
  // Ini untuk Form Add / Update 
  export const distributorRequest = createRequestFields<Distributor>([
    { label: 'Name Sold To', name: 'nameSoldTo' , dataType:'string'},
    { label: 'Name Ship To', name: 'nameShipTo' , dataType:'string'},
    { label: 'Sold To', name: 'soldTo' , dataType:'string'},
    { label: 'Ship To', name: 'shipTo', dataType:'string' },
    { label: 'Name Ship To SAP', name: 'nameShipToSAP', dataType:'string' },
  ]);
  
  export const initialDistributorFormData = createInitialFormData<Distributor>(distributorRequest);
  